import { HttpService, Repository, RepositoryBase, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { UnitModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { UnitBO } from './unit.bo';


@Repository({
    boType: UnitBO,
    apiController: TaggedUrl.join('products/units', [Tags.Api])
})
export class UnitRepositoryBase extends RepositoryBase<UnitBO, UnitModel> {
    public constructor(
        http: HttpService,
        private readonly weaver: Weaver
    ) {
        super(http);
    }

    protected createBO(): UnitBO {
        return new UnitBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: UnitModel) {
        return {
            id: model.id,
            version: model.version,
            default: model.default,
            name: model.name,
            symbol: model.symbol,
            externalId: model.externalId
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<UnitModel> {
        return new UnitModel(pickBy({
            id: item.id,
            version: item.version,
            default: item.default,
            name: item.name,
            symbol: item.symbol,
            externalId: item.externalId
        }, val => val !== void 0));
    }
}
